// src/components/Anggota.jsx
import React, { useEffect, useState } from "react";

const ROLE_OPTIONS    = ["administrator", "pegawai", "anggota"];
const STATUS_OPTIONS  = ["Aktif", "Tertunda", "Nonaktif"];
const ITEMS_PER_PAGE  = 10;

// ─── Modal Edit ───────────────────────────────────────────────────────────────
function EditModal({ anggota, onClose, onSave }) {
  const [form, setForm] = useState({
    member_no: anggota.member_no || "",
    name:      anggota.name      || "",
    nik:       anggota.nik       || "",
    phone:     anggota.phone     || "",
    address:   anggota.address   || "",
    email:     anggota.email     || "",
    status:    anggota.status    || "Aktif",
    username:  anggota.user?.username || "",
    role:      anggota.user?.role     || "anggota",
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await onSave(anggota.id, form);
    setLoading(false);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl p-6 max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-5">
          <h3 className="text-lg font-semibold">Edit Anggota</h3>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-600 text-2xl leading-none">×</button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid md:grid-cols-2 gap-3">
            <div>
              <label className="block text-xs text-slate-500 mb-1">No Anggota *</label>
              <input className="w-full rounded-xl border px-3 py-2 text-sm" value={form.member_no}
                onChange={(e) => setForm((f) => ({ ...f, member_no: e.target.value }))} required />
            </div>
            <div>
              <label className="block text-xs text-slate-500 mb-1">Nama *</label>
              <input className="w-full rounded-xl border px-3 py-2 text-sm" value={form.name}
                onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))} required />
            </div>
            <div>
              <label className="block text-xs text-slate-500 mb-1">NIK</label>
              <input className="w-full rounded-xl border px-3 py-2 text-sm" value={form.nik}
                onChange={(e) => setForm((f) => ({ ...f, nik: e.target.value }))} />
            </div>
            <div>
              <label className="block text-xs text-slate-500 mb-1">Telepon</label>
              <input className="w-full rounded-xl border px-3 py-2 text-sm" value={form.phone}
                onChange={(e) => setForm((f) => ({ ...f, phone: e.target.value }))} />
            </div>
            <div>
              <label className="block text-xs text-slate-500 mb-1">Email</label>
              <input className="w-full rounded-xl border px-3 py-2 text-sm" type="email" value={form.email}
                onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))} />
            </div>
            <div>
              <label className="block text-xs text-slate-500 mb-1">Alamat</label>
              <input className="w-full rounded-xl border px-3 py-2 text-sm" value={form.address}
                onChange={(e) => setForm((f) => ({ ...f, address: e.target.value }))} />
            </div>
            <div>
              <label className="block text-xs text-slate-500 mb-1">Status *</label>
              <select className="w-full rounded-xl border px-3 py-2 text-sm" value={form.status}
                onChange={(e) => setForm((f) => ({ ...f, status: e.target.value }))}>
                {STATUS_OPTIONS.map((s) => <option key={s} value={s}>{s}</option>)}
              </select>
            </div>
            <div>
              <label className="block text-xs text-slate-500 mb-1">Role *</label>
              <select className="w-full rounded-xl border px-3 py-2 text-sm" value={form.role}
                onChange={(e) => setForm((f) => ({ ...f, role: e.target.value }))}>
                {ROLE_OPTIONS.map((r) => <option key={r} value={r}>{r}</option>)}
              </select>
            </div>
          </div>

          <div className="border-t pt-4">
            <p className="text-xs text-slate-400 mb-3">Akun Login</p>
            <div className="grid md:grid-cols-2 gap-3">
              <div>
                <label className="block text-xs text-slate-500 mb-1">Username *</label>
                <input className="w-full rounded-xl border px-3 py-2 text-sm" value={form.username}
                  onChange={(e) => setForm((f) => ({ ...f, username: e.target.value }))} required />
              </div>
              <div>
                <label className="block text-xs text-slate-500 mb-1">Password</label>
                <input className="w-full rounded-xl border px-3 py-2 text-sm bg-slate-50 text-slate-400 cursor-not-allowed"
                  value="••••••••" disabled />
                <p className="text-xs text-slate-400 mt-1">Password tidak dapat diubah dari sini</p>
              </div>
            </div>
          </div>

          <div className="flex gap-2 pt-2">
            <button type="submit" disabled={loading}
              className="flex-1 bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white rounded-xl py-2 text-sm font-medium">
              {loading ? "Menyimpan..." : "Simpan Perubahan"}
            </button>
            <button type="button" onClick={onClose}
              className="flex-1 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-xl py-2 text-sm">
              Batal
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

// ─── Main Component ───────────────────────────────────────────────────────────
export default function AnggotaPage({ api }) {
  const [anggota, setAnggota]               = useState([]);
  const [loading, setLoading]               = useState(false);
  const [showForm, setShowForm]             = useState(false);
  const [editingAnggota, setEditingAnggota] = useState(null);
  const [currentPage, setCurrentPage]       = useState(1);
  const [searchQuery, setSearchQuery]       = useState("");

  const [form, setForm] = useState({
    member_no: "", name: "", nik: "", phone: "",
    email: "", address: "", status: "Aktif",
    role: "anggota", username: "", password: "",
  });

  const fetchAnggota = async () => {
    try {
      setLoading(true);
      const { data } = await api.get("/members?per_page=500");
      setAnggota(data.data || data);
    } catch (e) {
      console.error(e);
      alert("Gagal memuat data anggota.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAnggota();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery]);

  const resetForm = () => setForm({
    member_no: "", name: "", nik: "", phone: "",
    email: "", address: "", status: "Aktif",
    role: "anggota", username: "", password: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/members", form);
      await fetchAnggota();
      resetForm();
      setShowForm(false);
      setCurrentPage(1);
      alert("Anggota berhasil ditambahkan");
    } catch (e) {
      alert("Gagal menyimpan: " + (e.response?.data?.message || e.message));
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Hapus anggota ini? Data user login terkait juga akan dihapus.")) return;
    try {
      await api.delete(`/members/${id}`);
      await fetchAnggota();
      setCurrentPage(1);
    } catch (e) {
      alert("Gagal menghapus: " + (e.response?.data?.message || e.message));
    }
  };

  const handleSaveEdit = async (id, formData) => {
    try {
      await api.put(`/members/${id}`, formData);
      await fetchAnggota();
      setEditingAnggota(null);
      alert("Data anggota berhasil diperbarui");
    } catch (e) {
      alert("Gagal memperbarui: " + (e.response?.data?.message || e.message));
    }
  };

  // ── Filter / Search ──────────────────────────────────────────────────────────
  const filtered = anggota.filter((a) => {
    if (!searchQuery.trim()) return true;
    const q = searchQuery.toLowerCase();
    return (
      a.member_no?.toLowerCase().includes(q) ||
      a.name?.toLowerCase().includes(q)      ||
      a.nik?.toLowerCase().includes(q)       ||
      a.phone?.toLowerCase().includes(q)     ||
      a.email?.toLowerCase().includes(q)     ||
      a.address?.toLowerCase().includes(q)   ||
      a.user?.username?.toLowerCase().includes(q) ||
      a.user?.role?.toLowerCase().includes(q)     ||
      a.status?.toLowerCase().includes(q)
    );
  });

  // ── Pagination ───────────────────────────────────────────────────────────────
  const totalPages = Math.ceil(filtered.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const paginated  = filtered.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  return (
    <div className="space-y-6">

      {/* ── Header ── */}
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold">Data Anggota</h2>
        <button
          onClick={() => { setShowForm((v) => !v); resetForm(); }}
          className="bg-blue-600 hover:bg-blue-700 text-white rounded-xl px-4 py-2"
        >
          + Anggota Baru
        </button>
      </div>

      {/* ── Form Tambah (toggle) ── */}
      {showForm && (
        <div className="rounded-2xl bg-white border p-5">
          <h3 className="text-lg font-semibold mb-4">Tambah Anggota Baru</h3>
          <form onSubmit={handleSubmit} className="grid md:grid-cols-3 gap-3">
            <input className="rounded-xl border px-3 py-2" placeholder="No Anggota"
              value={form.member_no} onChange={(e) => setForm((f) => ({ ...f, member_no: e.target.value }))} required />
            <input className="rounded-xl border px-3 py-2" placeholder="Nama"
              value={form.name} onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))} required />
            <input className="rounded-xl border px-3 py-2" placeholder="NIK"
              value={form.nik} onChange={(e) => setForm((f) => ({ ...f, nik: e.target.value }))} />
            <input className="rounded-xl border px-3 py-2" placeholder="Telepon"
              value={form.phone} onChange={(e) => setForm((f) => ({ ...f, phone: e.target.value }))} />
            <input className="rounded-xl border px-3 py-2" placeholder="Email" type="email"
              value={form.email} onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))} />
            <input className="rounded-xl border px-3 py-2" placeholder="Alamat"
              value={form.address} onChange={(e) => setForm((f) => ({ ...f, address: e.target.value }))} />
            <select className="rounded-xl border px-3 py-2" value={form.status}
              onChange={(e) => setForm((f) => ({ ...f, status: e.target.value }))}>
              {STATUS_OPTIONS.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
            <select className="rounded-xl border px-3 py-2" value={form.role}
              onChange={(e) => setForm((f) => ({ ...f, role: e.target.value }))}>
              {ROLE_OPTIONS.map((r) => <option key={r} value={r}>{r}</option>)}
            </select>

            <div className="md:col-span-3 border-t pt-3 mt-1">
              <p className="text-xs text-slate-400 mb-3">Akun Login Anggota</p>
              <div className="grid md:grid-cols-3 gap-3">
                <input className="rounded-xl border px-3 py-2" placeholder="Username"
                  value={form.username} onChange={(e) => setForm((f) => ({ ...f, username: e.target.value }))} required />
                <input className="rounded-xl border px-3 py-2" type="password"
                  placeholder="Password (min. 8 karakter)"
                  value={form.password} onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))} required />
              </div>
            </div>

            <div className="md:col-span-3 flex gap-2">
              <button type="submit"
                className="bg-blue-600 hover:bg-blue-700 text-white rounded-xl py-2 px-6">
                Simpan
              </button>
              <button type="button" onClick={() => { setShowForm(false); resetForm(); }}
                className="bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-xl py-2 px-6">
                Batal
              </button>
            </div>
          </form>
        </div>
      )}

      {/* ── Search Bar — lebar proporsional seperti filter di Transaksi ── */}
      <div className="flex items-center gap-2">
        <div className="relative">
          <input
            type="text"
            placeholder="Cari anggota..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="border rounded-xl px-3 py-2 text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-300"
            style={{ width: "220px" }}
          />
          {searchQuery && (
            <button
              onClick={() => setSearchQuery("")}
              className="absolute right-3 top-2.5 text-slate-400 hover:text-slate-600 text-sm"
            >
              ×
            </button>
          )}
        </div>
        {searchQuery && (
          <span className="text-xs text-slate-400">{filtered.length} hasil</span>
        )}
      </div>

      {/* ── Tabel Anggota ── */}
      <div className="rounded-2xl border bg-white overflow-hidden">
        {loading ? (
          <div className="p-5 text-sm text-slate-500">Memuat data...</div>
        ) : (
          <>
            <div className="overflow-x-auto">
              <table className="w-full text-sm" style={{ tableLayout: "fixed", minWidth: "640px" }}>
                <colgroup>
                  <col style={{ width: "5%" }}  /> {/* ID */}
                  <col style={{ width: "12%" }} /> {/* No Anggota */}
                  <col style={{ width: "14%" }} /> {/* Nama */}
                  <col style={{ width: "14%" }} /> {/* Telepon */}
                  <col style={{ width: "20%" }} /> {/* Email */}
                  <col style={{ width: "11%" }} /> {/* Role */}
                  <col style={{ width: "10%" }} /> {/* Status */}
                  <col style={{ width: "14%" }} /> {/* Aksi */}
                </colgroup>
                <thead className="bg-slate-50">
                  <tr>
                    {["ID", "No Anggota", "Nama", "Telepon", "Email", "Role", "Status", "Aksi"].map((col) => (
                      <th key={col} className="text-left font-semibold px-4 py-3 text-slate-600">
                        {col}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {paginated.length === 0 && (
                    <tr>
                      <td colSpan={8} className="px-4 py-6 text-center text-slate-400">
                        {searchQuery ? `Tidak ada hasil untuk "${searchQuery}"` : "Belum ada data anggota."}
                      </td>
                    </tr>
                  )}
                  {paginated.map((a) => (
                    <tr key={a.id} className="border-t hover:bg-slate-50">
                      <td className="px-4 py-3 text-slate-700">{a.id}</td>
                      <td className="px-4 py-3">
                        <div className="truncate text-slate-700" title={a.member_no}>{a.member_no}</div>
                      </td>
                      <td className="px-4 py-3">
                        <div className="truncate text-slate-700" title={a.name}>{a.name}</div>
                      </td>
                      <td className="px-4 py-3">
                        <div className="truncate text-slate-700" title={a.phone || "-"}>{a.phone || "-"}</div>
                      </td>
                      <td className="px-4 py-3">
                        <div className="truncate text-slate-700" title={a.email || "-"}>{a.email || "-"}</div>
                      </td>
                      <td className="px-4 py-3">
                        <span className={`px-2 py-1 rounded-lg text-xs font-medium ${
                          a.user?.role === "administrator"
                            ? "bg-red-100 text-red-700"
                            : a.user?.role === "pegawai"
                            ? "bg-yellow-100 text-yellow-700"
                            : a.user?.role === "anggota"
                            ? "bg-blue-100 text-blue-700"
                            : "bg-slate-100 text-slate-400"
                        }`}>
                          {a.user?.role || "-"}
                        </span>
                      </td>
                      <td className="px-4 py-3">
                        <span className={`px-2 py-1 rounded-lg text-xs font-medium ${
                          a.status === "Aktif"
                            ? "bg-green-100 text-green-700"
                            : a.status === "Tertunda"
                            ? "bg-yellow-100 text-yellow-700"
                            : "bg-red-100 text-red-700"
                        }`}>
                          {a.status}
                        </span>
                      </td>
                      <td className="px-4 py-3">
                        <div className="flex gap-2">
                          <button
                            onClick={() => setEditingAnggota(a)}
                            className="px-3 py-1 rounded-lg border border-blue-200 text-blue-600 hover:bg-blue-50 text-xs"
                          >
                            Edit
                          </button>
                          <button
                            onClick={() => handleDelete(a.id)}
                            className="px-3 py-1 rounded-lg border border-red-200 text-red-600 hover:bg-red-50 text-xs"
                          >
                            Hapus
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* ── Pagination ── */}
            {filtered.length > 0 && (
              <div className="flex items-center justify-between px-4 py-3 text-sm border-t bg-slate-50">
                <button
                  onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                  disabled={currentPage === 1}
                  className="px-3 py-2 bg-white border rounded-lg disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Previous
                </button>
                <span className="text-slate-600">
                  Page <strong>{currentPage}</strong> dari <strong>{totalPages}</strong>
                  {searchQuery && (
                    <span className="ml-2 text-slate-400">({filtered.length} hasil)</span>
                  )}
                </span>
                <button
                  onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
                  disabled={currentPage === totalPages}
                  className="px-3 py-2 bg-white border rounded-lg disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Next
                </button>
              </div>
            )}
          </>
        )}
      </div>

      {/* ── Modal Edit ── */}
      {editingAnggota && (
        <EditModal
          anggota={editingAnggota}
          onClose={() => setEditingAnggota(null)}
          onSave={handleSaveEdit}
        />
      )}
    </div>
  );
}